import GenericLayout from './genericLayout';

import template from './sectionLayout.hbs';

export default GenericLayout.extend({
  template,
  tagName: 'section',
  initialize(...args) {
    GenericLayout.prototype.initialize.apply(this, args);
  }
});
